document.addEventListener('adev:cart:updated', (event) => {
    const cartData = event.detail;

    const cartDrawerEl = document.querySelector('m-cart-drawer');
    if (cartDrawerEl) {
        cartDrawerEl.renderContents(cartData);

		console.log('cartData');
		console.log(cartData);
		
		if (cartData.hasOwnProperty('sections')) {
			const cartItemsSection = cartData.sections['cart-drawer'];

			const parser = new DOMParser();
			const doc = parser.parseFromString(cartItemsSection, 'text/html');
			const itemCountEl = doc.querySelector('[data-adev-cart-count]');

			if (itemCountEl) {
				console.log("itemCountEl.getAttribute('data-adev-cart-count')");
				console.log(itemCountEl);
				
				
				const newItemCount = parseInt(itemCountEl.getAttribute('data-adev-cart-count')) || 0;
				document.querySelectorAll('.m-cart-count-bubble').forEach(el => {
					el.textContent = newItemCount;
					if (newItemCount > 0) {
						el.classList.remove('m:hidden');
					} else {
						el.classList.add('m:hidden');
					}
				});
			}
		}

        if (cartDrawerEl.classList.contains('m-cart--empty')) cartDrawerEl.classList.remove('m-cart--empty');
    }
});

if (!customElements.get('adev-video-tag')) {
	customElements.define('adev-video-tag', class adevVideoTag extends HTMLElement {
		constructor() {
			super();

			this.autoplay = this.hasAttribute('data-autoplay') && this.getAttribute('data-autoplay') === 'true';

			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						if(this.autoplay) {
							this.togglePlay();
						} else {
							this.initVideo();
						}

						observer.unobserve(this);
					}
				});
			});

			observer.observe(this);
			
		}

		initVideo(){
			this.video = this.querySelector('video');

			if(!this.video) {
				const scriptEl = this.querySelector('script');

				this.innerHTML += scriptEl.innerHTML;
				this.video = this.querySelector('video');

				this.setVideoEventListeners();
			}
		}

		togglePlay(){
			this.initVideo();

			if (this.video.paused) {
				this.video.play();
			} else {
				this.video.pause();
			}
		}

		play(){
			this.initVideo();
			this.video.play();
		}

		pause(){
			this.initVideo();
			this.video.pause();
		}

		mute(){
			this.initVideo();
			this.video.muted = true;
		}

		unmute(){
			this.initVideo();
			this.video.muted = false;
		}

		toggleMute() {
			this.initVideo();

			if (this.video.muted) {
				this.video.muted = false;
			} else {
				this.video.muted = true;
			}
		}

		setVideoEventListeners(){
			this._onVideoMuted();

			this.video.addEventListener('play', this._onVideoPlay.bind(this));
			this.video.addEventListener('pause', this._onVideoPause.bind(this));
			this.video.addEventListener('volumechange', this._onVideoMuted.bind(this));

			const playButton = this.querySelector('[data-adev-video-tag="play"]');
			if (playButton) {
				playButton.addEventListener('click', this.togglePlay.bind(this));
			}

			const toggleMuteButton = this.querySelector('[data-adev-video-tag="mute"]');
			if (toggleMuteButton) {
				toggleMuteButton.addEventListener('click', this.toggleMute.bind(this));
			}

			this.addEventListener('touchstart', () => this._handleTouchStart());
			this.addEventListener('touchend', () => this._handleTouchEnd());
		}

		_onVideoPlay() {
			this.classList.add('adev--is-revealed');
			this.classList.add('adev--is-playing');
		}

		_onVideoPause() {
			this.classList.remove('adev--is-playing');
		}

		_onVideoMuted() {
			if (this.video.muted) {
				this.classList.add('adev--is-muted');
			} else {
				this.classList.remove('adev--is-muted');
			}
		}

		_handleTouchStart() {
			this.classList.add('adev--is-touching');
			clearTimeout(this._handleTouchStartTimeout);
		}

		_handleTouchEnd() {
			this._handleTouchStartTimeout = setTimeout(() => {
				this.classList.remove('adev--is-touching');
			}, 1000);
		}

		connectedCallback() {
		}

		disconnectedCallback() {
			const playButton = this.querySelector('[data-adev-video-tag="play"]');
			if (playButton) {
				playButton.removeEventListener('click', this.togglePlay.bind(this));
			}

			const toggleMuteButton = this.querySelector('[data-adev-video-tag="mute"]');
			if (toggleMuteButton) {
				toggleMuteButton.removeEventListener('click', this.toggleMute.bind(this));
			}

			if (this.video) {
				this.video.removeEventListener('play', this._onVideoPlay.bind(this));
				this.video.removeEventListener('pause', this._onVideoPause.bind(this));
				this.video.removeEventListener('volumechange', this._onVideoMuted.bind(this));
			}

			this.removeEventListener('touchstart', () => this._handleTouchStart());
			this.removeEventListener('touchend', () => this._handleTouchEnd());
		}

	});
}

if (!customElements.get('adev-quantity-selector')) {
	customElements.define('adev-quantity-selector', class adevQuantitySelector extends HTMLElement {
		constructor() {
			super();
		}

		increase() {
			const max = this.inputEl.getAttribute('max') ? parseInt(this.inputEl.getAttribute('max')) : 1000000;
			const min = this.inputEl.getAttribute('min') ? parseInt(this.inputEl.getAttribute('min')) : 1;

			let currentValue = parseInt(this.inputEl.value) || min;

			if (currentValue < max) {
				currentValue++;
				this.inputEl.value = currentValue;
				this.inputEl.dispatchEvent(new Event('change'));

				this.dispatchEvent(new CustomEvent('adev:quantity:changed', { detail: currentValue }));
			}
		}
		
		decrease() {
			const min = this.inputEl.getAttribute('min') ? parseInt(this.inputEl.getAttribute('min')) : 1;
			let currentValue = parseInt(this.inputEl.value) || min;

			if (currentValue > min) {
				currentValue--;
				this.inputEl.value = currentValue;
				this.inputEl.dispatchEvent(new Event('change'));

				this.dispatchEvent(new CustomEvent('adev:quantity:changed', { detail: currentValue }));
			}
		}

		connectedCallback() {
			this.inputEl = this.querySelector('[data-adev-quantity-selector="value"]');
			if (!this.inputEl) return;

			this.querySelectorAll('[data-adev-quantity-selector="up"]').forEach( button => {
				button.addEventListener('click', this.increase.bind(this));
			});

			this.querySelectorAll('[data-adev-quantity-selector="down"]').forEach( button => {
				button.addEventListener('click', this.decrease.bind(this));
			});
		}

		disconnectedCallback() {
			this.querySelectorAll('[data-adev-quantity-selector="up"]').forEach( button => {
				button.removeEventListener('click', this.increase.bind(this));
			});

			this.querySelectorAll('[data-adev-quantity-selector="down"]').forEach( button => {
				button.removeEventListener('click', this.decrease.bind(this));
			});
		}

	});
}